import React, { useRef } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import type { FieldConfig } from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import type { WatchersConfig } from '@atlassian/jira-issue-create-watchers/src/services/types.tsx';
import { useMinimizableModal } from '@atlassian/jira-minimizable-modal/src/controllers/use-minimizable-modal/index.tsx';
import { TransitionState } from '@atlassian/jira-minimizable-modal/src/controllers/use-minimizable-modal/types.tsx';
import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import { HeaderDropdown } from './dropdown-menu/index.tsx';
import Watchers from './watchers/index.tsx';

type Props = {
	watchersConfigurations?: WatchersConfig;
	fieldConfig?: FieldConfig;
};

export const ActionsContainer = (props: Props) => {
	const hasWatchersInitialized = useRef(false);
	const [{ dataFetchError, selectedProject }] = useFormContext();
	const { view, isTransitionInState } = useMinimizableModal();

	const shouldDisableActions = dataFetchError !== null;
	const shouldDisableHeaderDropdown = Boolean(shouldDisableActions || selectedProject === null);
	const shouldRenderActionsContainer =
		view === 'modal' &&
		isTransitionInState(['mini'], TransitionState.EXITED) &&
		!isMobileAndInMvpOrExistingUsersExperiment();

	if (!shouldRenderActionsContainer) {
		return null;
	}

	return (
		<ActionsContainerWrapper data-testid="issue-create.ui.modal.create-form.actions-container.actions-container">
			<Watchers
				configs={props.watchersConfigurations}
				hasWatchersInitialized={hasWatchersInitialized}
			/>
			<Box xcss={dropdownContainerStyles}>
				<HeaderDropdown isDisabled={shouldDisableHeaderDropdown} fieldConfig={props.fieldConfig} />
			</Box>
		</ActionsContainerWrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActionsContainerWrapper = styled.div({
	display: 'flex',
	position: 'relative',
	zIndex: 1,
});

const dropdownContainerStyles = xcss({
	marginLeft: 'space.100',
});
